import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/new-axelerate-logo.svg'
import _imports_1 from '../../assets/svgs/bell-white.svg'
import _imports_2 from '@/assets/icons/flags/mxn.png'
import _imports_3 from '@/assets/icons/flags/usd.png'


const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-white bg-primary py-2" }
const _hoisted_3 = { class: "container flex flex-row justify-between items-center" }
const _hoisted_4 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-9 w-9",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4 6h16M4 12h16M4 18h16"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-6"
}, null, -1)
const _hoisted_8 = { class: "flex flex-row items-center justify-end" }
const _hoisted_9 = { class: "lg:flex md:flex hidden flex-row lg:visible md:visble" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-6 w-6"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "/", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-6 w-6"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "=", -1)
const _hoisted_15 = {
  key: 0,
  class: "z-40 mt-8 top-0 text-black absolute bg-white rounded shadow border border-primary p-2"
}
const _hoisted_16 = {
  key: 1,
  class: "h-6 w-px bg-white ml-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuDropDown = _resolveComponent("MenuDropDown")!
  const _component_ResponsiveNavBar = _resolveComponent("ResponsiveNavBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "transition duration-300 ease-in-out mr-2 transform hover:scale-110",
              "aria-label": "Open Menu",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.drawer && _ctx.drawer(...args)))
            }, _hoisted_6),
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "flex flex-row mr-6 relative cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/notifications')))
              }, [
                _hoisted_10,
                _createElementVNode("span", {
                  class: _normalizeClass(["flex flex-col justify-center items-center absolute rounded-full h-6 w-6 p-0.5 -top-3 left-2 text-xs border-pink-600 border-1", _ctx.notification <= 0 ? 'bg-green-600 ' : 'bg-pink-600 '])
                }, _toDisplayString(_ctx.notification ? _ctx.notification : 0), 3)
              ]),
              (_ctx.roles[0] === 'superadmin')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "relative flex flex-row items-center",
                    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = true)),
                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false))
                  }, [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(_ctx.exchangeRate), 1),
                    (_ctx.showTooltip)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 30-day rolling average "))
                      : _createCommentVNode("", true)
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.roles[0] === 'superadmin')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_MenuDropDown, { onLogOut: _ctx.logOut }, null, 8, ["onLogOut"])
          ])
        ])
      ])
    ]),
    _createVNode(_Transition, {
      "enter-class": "opacity-0",
      "enter-active-class": "ease-out transition-medium",
      "enter-to-class": "opacity-100",
      "leave-class": "opacity-100",
      "leave-active-class": "ease-out transition-medium",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.isOpen = false), ["esc"])),
          class: "z-10 fixed inset-0 transition-opacity"
        }, [
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpen = false)),
            class: "absolute inset-0 bg-black opacity-50",
            tabindex: "0"
          })
        ], 544), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ResponsiveNavBar, {
      isOpen: _ctx.isOpen,
      onCloseNav: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isOpen = false))
    }, null, 8, ["isOpen"])
  ], 64))
}